import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';

import { OpenContentDetailDialogAction } from '../../../actions/spaces/OpenContentDetailDialogActions';
import { ContentDetailsDialog } from '../../../content/contentDetailDialog/ContentDetailsDialog';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { Messages } from '../../../../codegen/Localize';
import { OpenContentDetailDialog } from '../../../actions/AppActionTypes';

// Open Detail Dialog
export function* handleOpenContentDetailDialog(action: OpenContentDetailDialogAction) {
  try {
    yield call(ContentDetailsDialog.open, action.content, action.availableActions);
  } catch(e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootContentDetailDialogSaga(): SagaIterator {
  yield takeLatest(OpenContentDetailDialog, handleOpenContentDetailDialog);
}
